export default "__VITE_ASSET__DVP$INdO__"